import { workspaceModel } from 'APP/model/model';

export async function revokeAdminFromWorkspace(userIds: string[]): Promise<boolean> {
  try {
    await workspaceModel.revokeFromAdmin(userIds);

    return true;
  } catch {
    return false;
  }
}
